module.exports = __webpack_public_path__ + "img/logo_with_name.1fadd52d.jpg";